/** @format */

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import MvnoBlockApiRequest from '../../interfaces/platform/MvnoBlockApiRequest';
import GridItem from '../../components/Grid/GridItem';
import GridContainer from '../../components/Grid/GridContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import I18n from '../../components/Translate/I18n';
import TableBody from '@material-ui/core/TableBody';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import Order from '../../interfaces/forms/Order';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { store } from '../../core/store';
import { provConstant, provReducer } from '../../modules/provisioning/ProvisioningConnect';
import ApiCollectionResponseInterface from '../../interfaces/api/ApiCollectionResponseInterface';
import Pager from '../../components/Adescom/PagerRange';
import { Input, InputAdornment, TableFooter } from '@material-ui/core';
import ApiDialog from './components/ApiDialog';
import Filter from '../../interfaces/forms/Filter';
import { DateHelperTs } from '../../helpers/DateHelperTs';
import TableHeaderContentCell from '../../components/Table/TableHeaderContentCell';
import moment, { Moment } from 'moment';
import Datetime from 'react-datetime';
import { FilterHelper } from '../lib/search/FilterHelper';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import { Magnify } from 'mdi-material-ui';
import { PlatformResellerCollectionInterface } from '../../interfaces/collections/PlatformResellerCollectionInterface';
import CustomTextButtom from '../../components/Buttons/CustomTextButton';
import { FilterManager } from '../../modules/filter/FilterManager';
import { FilterReducerFieldName } from '../../modules/filter/FilterReducers';
import FilterList from '../../components/Filter/FilterList';
import { FilterListReducerFieldName } from '../../modules/filter/FilterListReducers';
import PaperedTable from '../../components/Table/PaperedTable';
import { ListPropsInterface } from '../../modules/lib/ListPropsInterface';
import { ApiListRestItem } from './components/ApiListRestItem';
import oplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';
import OPL_STYLE from '../../assets/themes/OPL/OplStyle';
import MvnoBlockListInterface from '../../interfaces/platform/MvnoBlockListInterface';
import { MvnoBlockListCollectionInterface } from '../../interfaces/collections/MvnoBlockListCollectionInterface';

interface MvnoBlockApiRequestCollectionInterface extends ApiCollectionResponseInterface {
    readonly 'hydra:member': Array<MvnoBlockApiRequest> | null;
}

interface HeaderMvnoBlockListCollectionInterface extends ApiCollectionResponseInterface {
    readonly 'hydra:member': Array<MvnoBlockListInterface> | null;
}

interface ApiListState {
    orders: Array<Order>;
    filters: Array<Filter>;
    viewDialog: boolean;
    viewContent: any | null;
    viewTitle: any | string | null;
    currentPeriod: Moment;
    apiRequestQuery: string | null;
    apiResponseQuery: string | null;
    platformResellerList: PlatformResellerCollectionInterface | null;
    showClearFilterButton: boolean;
    activeRow: number;
    mvnoBlockList: MvnoBlockListCollectionInterface | null;
}

interface ApiListProps extends ListPropsInterface {
    items: MvnoBlockApiRequestCollectionInterface | null;
}

class ApiList extends PureComponent<ApiListProps, ApiListState> {
    private loaderCall: ItemLoaders;
    private filterManage: FilterManager;

    constructor(props: ApiListProps, context: ApiListProps) {
        super(props, context);
        store.injectReducer('provReducer', provReducer, true);
        const currentPeriod = moment();
        this.state = {
            currentPeriod: currentPeriod,
            viewDialog: false,
            viewContent: null,
            viewTitle: null,
            orders: [],
            apiRequestQuery: null,
            apiResponseQuery: null,
            platformResellerList: null,
            activeRow: 0,
            filters: [
                { name: 'createdAt[after]', value: DateHelperTs.getMonthFirstDaySimple(currentPeriod, 'YYYY-MM-01') },
                { name: 'createdAt[before]', value: DateHelperTs.addMonthsToDate(currentPeriod, 1).format('YYYY-MM-01') },
            ],
            showClearFilterButton: false,
            mvnoBlockList: null,
        };
        this.loaderCall = new ItemLoaders(this.props.dispatch);
        this.filterManage = new FilterManager();
    }

    componentDidMount = (): void => {
        // if (Auth.isAdminMode() || Auth.isAdminExpertMode()) {
        this.loadPlatformResellers();
        // }
        this.firstLoad();
    };

    componentDidUpdate(prevProps: Readonly<ApiListProps>, prevState: Readonly<ApiListState>, snapshot?: any): void {
        const { dispatch, headerFilterElementHasValue, headerFilterElementName } = this.props;
        if (headerFilterElementName) {
            if (headerFilterElementHasValue) {
                this.filterManage.manageElement(headerFilterElementName, headerFilterElementHasValue);
            } else {
                this.filterManage.manageElement(headerFilterElementName, false);
            }
            this.setState({ showClearFilterButton: this.filterManage.hasManageElement() });
            dispatch({
                type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
            });
        }
    }

    setActiveRow = (id: number): void => {
        const { activeRow } = this.state;
        if (activeRow === id) {
            id = 0;
        }
        this.setState({ activeRow: id });
    };

    loadPlatformResellers = (): void => {
        this.loaderCall.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/platform_resellers')),
            'plus_orders_common_response_platform_resllers_list',
            [],
            [],
            (data: PlatformResellerCollectionInterface): void => {
                this.setState({ platformResellerList: data });
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    viewDialog = (title: any | string | null, content: any | null): void =>
        this.setState({
            viewDialog: true,
            viewContent: content,
            viewTitle: title,
        });
    hideDialog = (): void => this.setState({ viewDialog: false, viewContent: null });

    paginationCallbackFunction = (uri: string): void => {
        this.props.showMainLoader(true);
        this.loaderCall.paginationCallWithCallback(
            uri,
            provConstant.MVNO_BLOCK_API_REQUEST_LIST,
            () => {
                this.props.showMainLoader(false);
            },
            { propagateDataToCallback: true, dispatchAfterCallback: true }
        );
    };

    firstLoad = (): void => {
        const { filters, orders } = this.state;
        const { dispatch } = this.props;
        this.props.showMainLoader(true);
        this.loaderCall.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/mvno_block_api_requests')),
            provConstant.MVNO_BLOCK_API_REQUEST_LIST,
            filters,
            orders,
            (): void => {
                this.props.showMainLoader(false);
                dispatch({
                    type: FilterListReducerFieldName.HEADER_FILTER_MANAGE,
                    showRender: true,
                });
            },
            { propagateDataToCallback: false, dispatchAfterCallback: true }
        );
        this.getMvnoBlockList();
    };

    updatePeriod = (date: string, fieldName: string): void => {
        let moment1 = moment(date);
        let filterHelper = new FilterHelper(this.state, { rangeFlag: false });
        let filter = filterHelper.updateField(fieldName + '[after]', DateHelperTs.getMonthFirstDaySimple(moment1, 'YYYY-MM-01'));
        if (filter === null) {
            return;
        }
        this.setState({ filters: filter }, (): void => {
            filterHelper = new FilterHelper(this.state, { rangeFlag: false });
            filter = filterHelper.updateField(fieldName + '[before]', DateHelperTs.addMonthsToDate(moment1, 1).format('YYYY-MM-01'));
            if (filter) {
                this.updateFilterList(filter);
            }
        });
    };

    updateSearachApiRequest = (): void => {
        const { apiRequestQuery } = this.state;
        let filterHelper = new FilterHelper(this.state, { rangeFlag: false });
        let filter: Array<Filter> | null = null;
        if (!apiRequestQuery) {
            filter = filterHelper.updateField('apiRequestQuery', '');
        } else {
            filter = filterHelper.updateField('apiRequestQuery', apiRequestQuery);
        }
        if (filter) {
            this.updateFilterList(filter);
        }
    };

    updateSearachApiResponse = (): void => {
        const { apiResponseQuery } = this.state;
        let filter: Array<Filter> | null = null;
        let filterHelper = new FilterHelper(this.state, { rangeFlag: false });
        if (!apiResponseQuery) {
            filter = filterHelper.updateField('apiResponseQuery', '');
        } else {
            filter = filterHelper.updateField('apiResponseQuery', apiResponseQuery);
        }
        if (filter) {
            this.updateFilterList(filter);
        }
    };

    updateOrderList = (orders: Array<Order>): void => this.setState({ orders: orders }, this.firstLoad);
    updateFilterList = (filters: Array<Filter>): void => this.setState({ filters: filters });

    setDefaultFilter = (callback: () => void): void => {
        const currentPeriod = moment();
        this.setState(
            {
                showClearFilterButton: false,
                filters: [
                    { name: 'createdAt[after]', value: DateHelperTs.getMonthFirstDaySimple(currentPeriod, 'YYYY-MM-01') },
                    { name: 'createdAt[before]', value: DateHelperTs.addMonthsToDate(currentPeriod, 1).format('YYYY-MM-01') },
                ],
                orders: [{ value: 'desc', name: 'id' }],
            },
            (): void => {
                if (callback) {
                    callback();
                }
                this.firstLoad();
            }
        );
    };

    clearFilter = (): void => {
        this.setDefaultFilter(() => {
            this.setState({ showClearFilterButton: false }, (): void => {
                const { dispatch } = this.props;
                dispatch({
                    type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
                    clearAll: true,
                });
                dispatch({
                    type: FilterListReducerFieldName.HEADER_FILTER_MANAGE,
                });
            });
        });
    };

    getMvnoBlockList = (): void => {
        this.loaderCall.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/mvno_block_lists')),
            provConstant.MVNO_BLOCK_LIST_LIST,
            [
                { name: 'deleted', value: false },
                { name: 'defaultGlobal', value: true },
                { name: 'pagination', value: false },
            ],
            [{ name: 'blockName', value: 'asc' }],
            (data: MvnoBlockListCollectionInterface): void => {
                if (data['hydra:totalItems'] && data['hydra:totalItems'] > 0) {
                    this.setState({
                        mvnoBlockList: data,
                    });
                }
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    render(): React.ReactNode {
        const { items, classes } = this.props;
        const { viewDialog, viewContent, viewTitle, filters, orders, platformResellerList, showClearFilterButton, activeRow } = this.state;

        const tableStickyHeader = { root: classes.tableStickyHeader };
        const tableControlStickyHeader = { root: classes.tableControlStickyHeader };
        const tableStickyCommand = { root: classes.tableStickyCommand };

        if (!this.state.mvnoBlockList) {
            return <div></div>;
        }

        return (
            <GridContainer>
                <GridItem xs={12} md={12} lg={12}>
                    <PaperedTable
                        beforeTableContent={
                            <GridContainer>
                                <GridItem xs={12} className={classes.beforeTableContent}>
                                    <CustomTextButtom
                                        callback={this.firstLoad}
                                        callbackParam={{}}
                                        color="primary"
                                        label="general:common.search"
                                        size="lg"
                                    />
                                    {showClearFilterButton && (
                                        <CustomTextButtom
                                            callback={this.clearFilter}
                                            callbackParam={{}}
                                            color="primary"
                                            label="general:common.clear"
                                            size="lg"
                                        />
                                    )}
                                </GridItem>
                                <GridItem xs={12}>
                                    <FilterList />
                                </GridItem>
                            </GridContainer>
                        }
                    >
                        <TableHead>
                            <TableRow>
                                <TableCell classes={tableControlStickyHeader} colSpan={7}>
                                    <GridContainer spacing={1}>
                                        <GridItem xs={2} style={{ marginTop: 15 }} className={classes.beforeTableContent}>
                                            <I18n trans="prov:h.search_period" />
                                            <Datetime
                                                className={'top-table-date-picker'}
                                                locale="pl"
                                                {...this.props}
                                                viewMode="months"
                                                defaultValue={moment(DateHelperTs.getCurrentDateSimple('YYYY-MM-01'))}
                                                dateFormat="YYYY-MM"
                                                timeFormat={false}
                                                onChange={(moment: Moment | string): void => {
                                                    if (typeof moment !== 'string') {
                                                        this.updatePeriod(moment.format('YYYY-MM-01'), 'createdAt');
                                                    }
                                                }}
                                                inputProps={{
                                                    id: 'createdAt',
                                                    placeholder: 'YYYY-MM',
                                                }}
                                            />
                                        </GridItem>
                                        <GridItem xs={3} style={{ marginTop: 22 }} className={classes.beforeTableContent}>
                                            <FormControl fullWidth={true}>
                                                <InputLabel>
                                                    <I18n trans="prov:h.message_request" />
                                                </InputLabel>
                                                <Input
                                                    id="apiRequestRequest"
                                                    onChange={(event): void => this.setState({ apiRequestQuery: event.target.value })}
                                                    onClick={(): void => {}}
                                                    name="apiRequestRequest"
                                                    endAdornment={
                                                        <InputAdornment
                                                            position="start"
                                                            onClick={this.updateSearachApiRequest}
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            <Magnify fontSize={'small'} />
                                                        </InputAdornment>
                                                    }
                                                />
                                            </FormControl>
                                        </GridItem>
                                        <GridItem xs={3} style={{ marginTop: 22 }} className={classes.beforeTableContent}>
                                            <FormControl fullWidth={true}>
                                                <InputLabel>
                                                    <I18n trans="prov:h.message_response" />
                                                </InputLabel>
                                                <Input
                                                    id="apiResponseQuery"
                                                    onChange={(event): void => this.setState({ apiResponseQuery: event.target.value })}
                                                    onClick={(): void => {}}
                                                    name="apiResponseQuery"
                                                    endAdornment={
                                                        <InputAdornment
                                                            position="start"
                                                            onClick={this.updateSearachApiResponse}
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            <Magnify fontSize={'small'} />
                                                        </InputAdornment>
                                                    }
                                                />
                                            </FormControl>
                                        </GridItem>
                                    </GridContainer>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell classes={tableStickyCommand} padding="none" align="left">
                                    <TableHeaderContentCell textAlign="left" title="general:common.commands" onlyFilter={true} />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="left">
                                    <TableHeaderContentCell
                                        textAlign="left"
                                        title="prov:list.id"
                                        fieldName="id"
                                        showSort={true}
                                        onlyFilter={true}
                                        defaultDirection="desc"
                                        searchFieldType="number"
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                {/*{(Auth.isAdminMode() || Auth.isAdminExpertMode()) && (*/}
                                <TableCell classes={tableStickyHeader} padding="none" align="center">
                                    <TableHeaderContentCell
                                        title="prov:list.partner"
                                        textAlign="center"
                                        fieldName="platformResellerId"
                                        showSort={true}
                                        onlyFilter={false}
                                        defaultDirection="desc"
                                        searchFieldType="select"
                                        selectComponent="headerCheckBoxSimpleList"
                                        elementList={
                                            platformResellerList
                                                ? platformResellerList?.['hydra:member'].map((el: any) => {
                                                      return { name: el.mainname, value: el.id };
                                                  })
                                                : []
                                        }
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="center">
                                    <TableHeaderContentCell
                                        title="prov:list.operator_name"
                                        fieldName="platformUserName"
                                        showSort={true}
                                        onlyFilter={true}
                                        defaultDirection="desc"
                                        searchFieldType="string"
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="center">
                                    <TableHeaderContentCell
                                        title="prov:list.block"
                                        fieldName="mvnoBlockListId"
                                        showSort={true}
                                        onlyFilter={true}
                                        defaultDirection="desc"
                                        searchFieldType="select"
                                        selectComponent="headerCheckBoxSimpleList"
                                        elementList={
                                            this.state.mvnoBlockList
                                                ? this.state.mvnoBlockList?.['hydra:member'].map((el: any) => {
                                                      return { name: el.blockName, value: el.id };
                                                  })
                                                : []
                                        }
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                        platformResellerList={platformResellerList ? platformResellerList?.['hydra:member'] : []}
                                        nullable={true}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="center">
                                    <TableHeaderContentCell
                                        title="prov:list.api_command"
                                        fieldName="apiCommand"
                                        showSort={true}
                                        onlyFilter={true}
                                        defaultDirection="desc"
                                        searchFieldType="string"
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="center">
                                    <TableHeaderContentCell
                                        title="prov:list.msisdn"
                                        fieldName="msisdn"
                                        showSort={true}
                                        onlyFilter={true}
                                        defaultDirection="desc"
                                        searchFieldType="number"
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                        nullable={true}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="center">
                                    <TableHeaderContentCell
                                        title="prov:list.imsi"
                                        fieldName="imsi"
                                        showSort={true}
                                        onlyFilter={true}
                                        defaultDirection="desc"
                                        searchFieldType="string"
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                        nullable={true}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="center">
                                    <TableHeaderContentCell
                                        title="IRI"
                                        fieldName="apiIri"
                                        showSort={true}
                                        onlyFilter={true}
                                        defaultDirection="desc"
                                        searchFieldType="string"
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="center">
                                    <TableHeaderContentCell
                                        title="prov:list.state"
                                        fieldName="apiState"
                                        showSort={true}
                                        onlyFilter={true}
                                        defaultDirection="desc"
                                        searchFieldType="select"
                                        selectComponent="headerApiOperationStateHelper"
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="center">
                                    <TableHeaderContentCell
                                        title="prov:list.api_request_start"
                                        fieldName="createdAt"
                                        showSort={true}
                                        onlyFilter={true}
                                        defaultDirection="asc"
                                        searchFieldType="date"
                                        dateFromTo={true}
                                        dateFormat="RRRR-MM-DD HH:MM"
                                        filters={filters}
                                        sort={orders}
                                        breakLine={true}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                        nullable={true}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="center">
                                    <TableHeaderContentCell
                                        title="prov:list.api_request_end"
                                        fieldName="responseAt"
                                        showSort={true}
                                        onlyFilter={true}
                                        defaultDirection="asc"
                                        searchFieldType="date"
                                        dateFormat="RRRR-MM-DD HH:MM"
                                        dateFromTo={true}
                                        filters={filters}
                                        sort={orders}
                                        breakLine={true}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                        nullable={true}
                                    />
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {items &&
                                items['hydra:member'] &&
                                items['hydra:member'].map((item) => {
                                    let rowActiveColor = 'white';
                                    if (activeRow === item.id) {
                                        rowActiveColor = OPL_STYLE.TABLE.ACTIVE_ROW;
                                    }
                                    return (
                                        <ApiListRestItem
                                            mvnoBlockList={this.state.mvnoBlockList}
                                            classes={this.props.classes}
                                            key={'apiRequest_' + item.id}
                                            item={item}
                                            viewDialog={this.viewDialog}
                                            setActiveRow={this.setActiveRow}
                                            rowActiveColor={rowActiveColor}
                                        />
                                    );
                                })}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TableCell colSpan={17}>
                                    {items && items['hydra:view'] && <Pager callback={this.paginationCallbackFunction} views={items} />}
                                </TableCell>
                            </TableRow>
                        </TableFooter>
                    </PaperedTable>
                    <ApiDialog open={viewDialog} fullWidth={true} closeCallback={this.hideDialog} content={viewContent} title={viewTitle} />
                </GridItem>
            </GridContainer>
        );
    }
}

const mapStateToProps = (state: any): object => {
    const { provReducer, filterReducer } = state;
    let returnObj = {} as { type: string; items: any; headerFilterElementHasValue: boolean; headerFilterElementName: string };
    if (provReducer && provReducer.type === provConstant.MVNO_BLOCK_API_REQUEST_LIST && provReducer.items) {
        returnObj.type = provReducer.type;
        returnObj.items = provReducer.items;
    }
    if (filterReducer && filterReducer.headerFilterElementName) {
        returnObj.headerFilterElementHasValue = filterReducer.headerFilterElementHasValue;
        returnObj.headerFilterElementName = filterReducer.headerFilterElementName;
    }
    return returnObj;
};

export default compose<any, any>(connect(mapStateToProps), withStyles(oplAppStyle))(ApiList);
